import { Injectable } from '@angular/core';
import {AngularFirestore} from '@angular/fire/firestore';
import {map} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class LicenseCodesService {

  constructor(
    public afs: AngularFirestore,
  ) { }

  setLicenseCode(code) {
    const id = code.createdAt;
    return this.afs.doc(`licenseCodes/id${id}`).set(code);
  }
  getLicenseCodes() {
    return this.afs.collection('licenseCodes').get().pipe(map(snapshot => snapshot.docs.map(doc => doc.data())));
  }

  getSingleLicenseCode(code: string) {
    return this.afs.collection(`licenseCodes`, ref => ref.where('code', '==', `${code}`)).get().pipe(map(snapshot => snapshot.docs.map(doc => doc.data())));
  }
  checkLicenseForSupervisor(supervisorId) {
    return this.afs.collection( 'licenseCodes', ref => ref.where('supervisor.id', '==', supervisorId) ) .get() .pipe( map(snapshot => snapshot.docs.map(doc => doc.data())));
  }
  deleteLicenseCode(code) {
    const id = code.createdAt;
    return this.afs.doc(`licenseCodes/id${id}`).delete();
  }
}
